import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalConnection() {
  return <section className="py-10 md:py-14 bg-chocolate" data-id="element-96">
      <div className="max-w-4xl mx-auto px-4" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-98">
          <p className="text-sm md:text-base font-bold tracking-[0.2em] text-copper uppercase mb-5" data-id="element-99">
            Because we all love our pets.
          </p>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight" data-id="element-100">
            It is not just a toy. <br className="hidden md:block" data-id="element-101" />
            It is <span className="text-copper italic" data-id="element-102">your pet</span>,
            crocheted with love.
          </h2>

          <div className="w-24 h-1 bg-copper mx-auto mt-8 rounded-full" data-id="element-103" />
        </motion.div>
      </div>
    </section>;
}